import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconChevronRightSmall = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M10.43 9.54a.74.74 0 0 1-.235-.54.74.74 0 0 1 .235-.54c.14-.14.312-.21.515-.21s.383.07.54.21l3 3c.14.157.21.337.21.54s-.07.383-.21.54l-3 3a.782.782 0 0 1-.54.21.701.701 0 0 1-.515-.21.741.741 0 0 1-.235-.54c0-.203.078-.383.235-.54L12.89 12l-2.46-2.46z" }),
});

export { IconChevronRightSmall };
